module.exports = __webpack_public_path__ + "media/c3.cc10ceaf.mp3";